import gs1Instance from '../api-index'

const { post, get, patch, put, } = gs1Instance

const getAllRoles = async params => {
  const response = await get(`/gs1/standard/roles`, params)
  return response.data
}


export { getAllRoles };
